import { render } from "./Logged.vue?vue&type=template&id=21f38b1e"
import script from "./Logged.vue?vue&type=script&lang=js"
export * from "./Logged.vue?vue&type=script&lang=js"

import exportComponent from "/home/tchery/dev/assiette-parfaite/frontend-gesit/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__